import { APP_ROUTE } from '../constants';

type QParametersObjectType = {
  [key: string]: string | number;
};

type QParametersDefinitonType = {
  name: string;
  value?: string;
  id?: string;
  priority: number;
};
export const QUERY_PARAMS: {
  [key: string]: QParametersDefinitonType;
} = {
  CLIENT: {
    name: 'client',
    priority: 4,
  },
  CHANNEL: {
    name: 'channel',
    value: 'value',
    id: 'id',
    priority: 3,
  },
  STARTDATE: {
    name: 'start',
    priority: 2,
  },
  ENDDATE: {
    name: 'end',
    priority: 1,
  },
};

const FORBIDDEN_QUERY_PARAMS_ROUTES_COMMON = [
  `${APP_ROUTE.SETTINGS}/${APP_ROUTE.PROFILE}`,
  `${APP_ROUTE.SETTINGS}/${APP_ROUTE.ACCOUNT}`,
  `${APP_ROUTE.SETTINGS}/${APP_ROUTE.BILLING}`,
  `${APP_ROUTE.SETTINGS}/${APP_ROUTE.CHECKOUT}`,
];

export const FORBIDDEN_QUERY_PARAMS_ROUTES = {
  [QUERY_PARAMS.CLIENT.name]: [...FORBIDDEN_QUERY_PARAMS_ROUTES_COMMON],
  // [QUERY_PARAMS.CHANNEL.name]: [
  //   ...FORBIDDEN_QUERY_PARAMS_ROUTES_COMMON,
  //   `${APP_ROUTE.ANALYTICS}/${APP_ROUTE.REPORTS}`,
  // ],
  // [QUERY_PARAMS.STARTDATE.name]: [
  //   ...FORBIDDEN_QUERY_PARAMS_ROUTES_COMMON,
  //   `${APP_ROUTE.ANALYTICS}/${APP_ROUTE.REPORTS}`,
  // ],
  // [QUERY_PARAMS.ENDDATE.name]: [
  //   ...FORBIDDEN_QUERY_PARAMS_ROUTES_COMMON,
  //   `${APP_ROUTE.ANALYTICS}/${APP_ROUTE.REPORTS}`,
  // ],
};

/**
 * @description Function to find a query parameter's definiton using its name
 */
const findUsingName = (name: string): null | QParametersDefinitonType => {
  const foundKeys = Object.keys(QUERY_PARAMS).filter(
    key => QUERY_PARAMS[key].name === name
  );
  if (foundKeys.length === 0) {
    return null;
  }
  return QUERY_PARAMS[foundKeys[0]];
};

/**
 * @description Function to sort the keys of JS object
 * according to a defined priority order of appearing in the query string
 */

export const sortQParamsKeys = (
  qParams: QParametersObjectType
): QParametersObjectType => {
  try {
    const sortedQParams: QParametersObjectType = {};

    // Create an array of [[priority, key]]
    const keys: [number, string][] = [];

    Object.keys(qParams).forEach(key => {
      // Check if its priority order is defined
      const found = findUsingName(key);
      if (found) {
        keys.push([found.priority, key]);
      } else {
        // Take 0 otherwise
        keys.push([0, key]);
      }
    });

    keys.sort((a, b) => {
      // If priority is same, sort the keys lexographically
      if (a[0] === b[0]) {
        return a[1].localeCompare(b[1]);
      }
      // Otherwise, put higher priority first
      return b[0] - a[0];
    });

    // Insert in the JS Object. It retains the insertion order of keys
    keys.forEach(item => {
      sortedQParams[item[1]] = qParams[item[1]];
    });

    return sortedQParams;
  } catch (e) {
    return {};
  }
};

/**
 * @description Function to parse the query string and convert it into JS object.
 */

export const parseQueryParameters = (query: string): QParametersObjectType => {
  try {
    const parsedParams = new URLSearchParams(query);
    const qParams: QParametersObjectType = {};
    parsedParams?.forEach((value: string, key: string) => {
      qParams[key] = value;
    });
    return qParams;
  } catch (e) {
    return {};
  }
};

/**
 * @description Function to stringify the given parameters and create a query string
 */

export const stringifyQueryParameters = (
  qParams: QParametersObjectType
): string => {
  try {
    const sortedQParams = sortQParamsKeys(qParams);
    const qString =
      (Object.keys(sortedQParams).length > 0 ? '?' : '') +
      new URLSearchParams(sortedQParams as any).toString();
    return qString;
  } catch (e) {
    return '';
  }
};

/**
 * @description Function to retrieve given parameters from the query parameters object.
 */

export const getQueryParameters = (
  qParams: QParametersObjectType,
  params: string[]
): QParametersObjectType => {
  try {
    const extractedParams: QParametersObjectType = {};
    params.forEach((value: string) => {
      if (value in qParams) {
        extractedParams[value] = qParams[value];
      }
    });
    return extractedParams;
  } catch (e) {
    return {};
  }
};

/**
 * @description Function to merge two given parameters objects.
 * For common parameters, it takes the value from second object.
 */

export const mergeParameters = (
  qParams1: QParametersObjectType,
  qParams2: QParametersObjectType
): QParametersObjectType => {
  try {
    const mergedParams: QParametersObjectType = { ...qParams1 };
    Object.keys(qParams2).forEach((key: string) => {
      mergedParams[key] = qParams2[key];
    });
    return mergedParams;
  } catch (e) {
    return {};
  }
};
